export default {
  // Inject the parents validator, to keep both in the same scope
  inject: ['$validator'],

  props: {
    noValidation: {
      type: Boolean,
      default: false,
    },

    validation: {
      type: String,
      default: '',
    },
  },

  // Provide functions to vee-validate to lookup value and name of component
  $_veeValidate: {
    name() {
      return this.name;
    },
    value() {
      return this.value;
    },
  },

  methods: {
    hlGetValidationError() {
      return this._hl_errors && this._hl_errors.first(this.name);
    },
    hlGetValidationRule() {
      if (this.noValidation) return null;

      if (this.validation !== '') return this.validation;

      // eslint-disable-next-line @typescript-eslint/no-this-alias
      let root = this;
      let depth = 0;
      while (!('hlValidationRules' in root)) {
        if (!('$parent' in root) || !root.$parent) {
          return null;
        }
        root = root.$parent;
        depth++;
        if (depth > 100) {
          return null;
        }
      }

      if (root.hlValidationRules === null) return;

      if (!('name' in this) || this.name === undefined) {
        return null;
      }

      if (this.name in root.hlValidationRules) {
        return root.hlValidationRules[this.name];
      }

      for (const i in root.hlValidationRegexRules) {
        if (this.name.match(i)) {
          return root.hlValidationRegexRules[i];
        }
      }

      return null;
    },
    hlIsFormValid() {
      return this.$validator ? !this.$validator.errors.any() : true;
    },
  },
};
